
import { se_1_slidedeck } from './SL44000Sprint01'
import { se_2_slidedeck } from './SL44000Sprint02'
import { se_3_slidedeck } from './SL44000Sprint03'
import { se_4_slidedeck } from './SL44000Sprint04'
import { se_5_slidedeck } from './SL44000Sprint05'

import { tUnderConstruction } from './SL00000Sprint00'

import { se_1_slidedeckTTR } from './SL44000Sprint01TTR'
import { se_2_slidedeckTTR } from './SL44000Sprint02TTR'
import { se_3_slidedeckTTR } from './SL44000Sprint03TTR'
import { se_4_slidedeckTTR } from './SL44000Sprint04TTR'
import { se_5_slidedeckTTR } from './SL44000Sprint05TTR'
import { se_6_slidedeckTTR } from './SL44000Sprint06TTR'
import { se_7_slidedeckTTR } from './SL44000Sprint07TTR'
import { se_8_slidedeckTTR } from './SL44000Sprint08TTR'

const uCSD = [ tUnderConstruction ] // A uCSD is an array of one tUnderConstruction slide.
const uCM = [ uCSD, uCSD, uCSD, uCSD, uCSD, uCSD ] // A uCM is an array of 6 class sessions each containing a UCSDs.

// The se_slidedeck structure is a multiple dimensional array of slidesdecks consisting of 8 modules of 6 classes each. 
// Each slidedeck is an array of 1 to n slides. 
export const se_slidedeck = [ se_1_slidedeck, se_2_slidedeck, se_3_slidedeck, se_4_slidedeck, se_5_slidedeck, uCM, uCM, uCM ]

// The se_slidedeckTTh structure is a multi-dimensional array of slidedecks for the Software Engineering course. Each
// element (i.e. se_1_slidedeckTTR) includes slidedecks for a full sprint. Specifically including a slidedeck for each 
// session with each slidedeck including 1 to n slides. 
export const _CPSC_44000_SLIDEDECK_TTR = [ se_1_slidedeckTTR, se_2_slidedeckTTR, se_3_slidedeckTTR, se_4_slidedeckTTR, 
	se_5_slidedeckTTR, se_6_slidedeckTTR, se_7_slidedeckTTR, se_8_slidedeckTTR ]